import * as React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

import { StripeWrapper } from './stripe-wrapper.component';
import { VirtualTerminal } from '../../virtual-terminal/virtual-terminal.component';

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact={true} path="/payment/:id?" component={StripeWrapper} />
        <Route exact={true} path="/terminal/:id?" component={VirtualTerminal} />
        <Redirect to="/payment/" />
      </Switch>
    </BrowserRouter>
  );
};
